export default __webpack_public_path__ + "static/media/angelstatue.e73d91f2.png";